import { objectSpread2 as _objectSpread2, toConsumableArray as _toConsumableArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { applyMiddleware, createStore, combineReducers, compose } from 'redux';

var defaultOptions = {
  reducers: {},
  middleware: [],
  enhancers: [],
  reduxDevTools: false,
  combineReducers: null
};
var store = undefined;
var reducers = {};
var storeOptions = defaultOptions; // manipulation function to prevent build minification obscuring
// raw config value when using deployment string substitution

var useReduxDevTools = function useReduxDevTools(value) {
  if (typeof value === "string") {
    return value.toUpperCase() === "TRUE";
  }

  return !!value;
};
/**
 * Creates a new Redux store for state management
 * @param {Object} options Configuration options for the store
 * @param {function} options.combineReducers Override the default combineReducers function from Redux
 * @param {Object} options.reducers Object containing the initial reducers for the store
 * @param {Array} options.middleware Redux middleware to apply to the store
 * @param {boolean|string} options.reduxDevTools Whether the Redux developer tools browser extension should be enabled, default false
 * @returns {Store} The newly created Store object
 */


var createReduxStore = function createReduxStore() {
  var _storeOptions$middlew, _storeOptions$enhance;

  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  storeOptions = _objectSpread2(_objectSpread2({}, defaultOptions), options);
  reducers = _objectSpread2({}, storeOptions.reducers);
  var composeEnhancer = compose;

  if (storeOptions.reduxDevTools && useReduxDevTools(storeOptions.reduxDevTools) && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
    composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
  }

  var storeEnhancer = composeEnhancer.apply(void 0, [applyMiddleware.apply(void 0, _toConsumableArray((_storeOptions$middlew = storeOptions.middleware) !== null && _storeOptions$middlew !== void 0 ? _storeOptions$middlew : []))].concat(_toConsumableArray((_storeOptions$enhance = storeOptions.enhancers) !== null && _storeOptions$enhance !== void 0 ? _storeOptions$enhance : [])));
  var newStore = createStore(storeOptions.combineReducers ? storeOptions.combineReducers(reducers) : combineReducers(reducers), storeEnhancer);
  store = newStore;
  return newStore;
};
/**
 * Updates the Redux store with new reducers.
 * Existing reducers with the same name will be replaced
 * @param {Object} newReducers Object containing the new reducers to apply
 */


var updateReducers = function updateReducers(newReducers) {
  if (!store) return;
  reducers = _objectSpread2(_objectSpread2({}, reducers), newReducers);
  store.replaceReducer(storeOptions.combineReducers ? storeOptions.combineReducers(reducers) : combineReducers(reducers));
};

export { createReduxStore, updateReducers };
